import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=7cc0ae8e&scoped=true"
import script from "./groupDetail.vue?vue&type=script&lang=js"
export * from "./groupDetail.vue?vue&type=script&lang=js"
import style0 from "./groupDetail.vue?vue&type=style&index=0&id=7cc0ae8e&prod&scoped=true&lang=scss"
import style1 from "./groupDetail.vue?vue&type=style&index=1&id=7cc0ae8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0ae8e",
  null
  
)

export default component.exports